<template>
  <div>
    <div>
      <aha-modal
        @hide="$emit('hide')"
        :title="title"
        action-position="justify-center"
      >
        <div>
          If the problem still occurs, please check your internet connection
          or contact us at
          <a href="mailto:hi@ahaslides.com">hi@ahaslides.com</a>
          for support.
        </div>

        <template #action>
          <aha-button @click="$emit('hide')">
            OK
          </aha-button>
        </template>
      </aha-modal>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
}
</script>
